<template>
  <div style="text-align: center;">
    <article class="notification mt-3 mb-3 ml-3 is-warning">
      <div class="media">
        <div class="media-left">
          <span class="icon is-large" aria-hidden="">
            <i class="mdi mdi-alert mdi-48px"></i>
          </span>
        </div>
        <div class="media-content my-auto">
          <strong>No matching results for filters.</strong> Below are your
          previous results. Try removing some filters to see more results.
        </div>
        <button
          @click="resetFilters"
          type="button"
          class="button is-primary my-auto"
        >
          <span>Reset filters</span>
        </button>
      </div>
    </article>
    <div class="end-divider"></div>
  </div>
</template>

<script>
export default {
  name: "FilterWarning",
  props: {},
  methods: {
    resetFilters() {
      this.$store.commit("flight/RESET_FILTERS")
      this.onFilterChange()
    },
  },
  inject: ["onFilterChange"],
}
</script>

<style scoped>
.end-divider {
  border: 1px dashed #ddddde;
  margin: 10px 0;
}
</style>
